import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import Flyouts from "./Flyouts";
var getClassName = getClassNameFactory(Flyouts.displayName);

var rehydrator = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren) {
    var childrenNode, reactifiedChildren, props;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            childrenNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "panel"
            })));
            _context.next = 3;
            return rehydrateChildren(childrenNode);

          case 3:
            reactifiedChildren = _context.sent;
            props = {
              summaryLinkHref: domNode.getAttribute("data-summary-link-href") || "",
              summaryLinkText: domNode.getAttribute("data-summary-link-text") || "",
              children: reactifiedChildren
            };
            return _context.abrupt("return", /*#__PURE__*/React.createElement(Flyouts, props));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function rehydrator(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export default rehydrator;